(() => {
  function init(root) {
    if (!root || root.dataset.kbReady === 'true') return;
    root.dataset.kbReady = 'true';

    const buttons = [...root.querySelectorAll('[data-kb-filter]')];
    const cards = [...root.querySelectorAll('[data-kb-category]')];

    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.kbFilter;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => {
        const hidden = filter !== 'all' && card.dataset.kbCategory !== filter;
        card.classList.toggle('is-hidden', hidden);
        card.setAttribute('aria-hidden', String(hidden));
      });
    }));

    buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === 0)));

    root.querySelectorAll('.kb-faq details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('.kb-faq details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-kb-home]').forEach(init);
  });
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-kb-home]'));
  });
})();
